import { render, staticRenderFns } from "./LineItem4.vue?vue&type=template&id=2a0ae7f1&scoped=true&"
import script from "./LineItem4.vue?vue&type=script&lang=js&"
export * from "./LineItem4.vue?vue&type=script&lang=js&"
import style0 from "./LineItem4.vue?vue&type=style&index=0&id=2a0ae7f1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0ae7f1",
  null
  
)

export default component.exports